import { useId, useRef, type FC } from "react";

import { type PropsWithClassName } from "@/components/podkit/lib/cn";

export const RubyMineLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.9543 0L13.0971 2.46857L7.68 0L2.36572 13.3371L8.46857 10.9029L8.36572 17.6571L21.4286 17.8971L24 4.69714L19.9543 0Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path
                d="M17.4171 7.78287L8.77714 2.12573L1.81714 6.41144L17.0743 12.3086L17.4171 7.78287Z"
                fill={`url(#paint1_linear_${id})`}
            />
            <path
                d="M9.97714 23.3829L18.96 22.1829L16.1143 16.6971L18 14.4L18.2057 12.9943L8.77714 2.09143L0 4.25143V16.8343L5.07429 24L9.97714 23.3829Z"
                fill={`url(#paint2_linear_${id})`}
            />
            <path d="M4.59428 4.59424H19.4057V19.4057H4.59428V4.59424Z" fill="black" />
            <path d="M6 16.6285H11.5543V17.5543H6V16.6285Z" fill="white" />
            <path
                d="M11.8629 6.51428H13.3371L14.9486 9.12L16.56 6.51428H18.0343V12.6514H16.6629V8.64L14.9486 11.28H14.9143L13.2 8.67429V12.6514H11.8629V6.51428Z"
                fill="white"
            />
            <path
                d="M5.96572 6.51428H8.77714C9.10061 6.49115 9.42541 6.53392 9.73187 6.64C10.0383 6.74608 10.3201 6.91326 10.56 7.13143C10.7356 7.31928 10.8716 7.54054 10.96 7.78203C11.0483 8.02352 11.0872 8.28032 11.0743 8.53714V8.57143C11.0918 9.00309 10.9584 9.42737 10.6971 9.77143C10.4541 10.0921 10.1193 10.3312 9.73714 10.4571L11.2457 12.6514H9.66857L8.4 10.7657H7.26857V12.6514H5.93143V6.51429L5.96572 6.51428ZM8.70857 9.49714C8.84401 9.51056 8.98077 9.49619 9.11046 9.45493C9.24016 9.41366 9.36007 9.34636 9.46286 9.25714C9.54792 9.17816 9.61609 9.08275 9.66323 8.97668C9.71037 8.8706 9.73552 8.75607 9.73714 8.64V8.60572C9.74614 8.48319 9.72597 8.36027 9.6783 8.24704C9.63062 8.1338 9.55679 8.03348 9.46286 7.95429C9.22962 7.8012 8.95258 7.72893 8.67429 7.74857H7.33714V9.49714H8.70857Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="17.0038"
                    y1="18.0207"
                    x2="10.3993"
                    y2="2.45802"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.172" stopColor="#FF1F51" />
                    <stop offset="0.28" stopColor="#FF3648" />
                    <stop offset="0.468" stopColor="#FF593B" />
                    <stop offset="0.646" stopColor="#FF7231" />
                    <stop offset="0.809" stopColor="#FF812B" />
                    <stop offset="0.941" stopColor="#FF8629" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="11.4061"
                    y1="4.41961"
                    x2="8.61045"
                    y2="11.465"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.022" stopColor="#9039D0" />
                    <stop offset="0.629" stopColor="#FF1F51" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="0.109812"
                    y1="3.84006"
                    x2="15.5363"
                    y2="23.4501"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.107" stopColor="#9039D0" />
                    <stop offset="0.387" stopColor="#FF1F51" />
                    <stop offset="0.629" stopColor="#FF1F51" />
                    <stop offset="0.66" stopColor="#FF3648" />
                    <stop offset="0.714" stopColor="#FF593B" />
                    <stop offset="0.765" stopColor="#FF7231" />
                    <stop offset="0.812" stopColor="#FF812B" />
                    <stop offset="0.85" stopColor="#FF8629" />
                </linearGradient>
            </defs>
        </svg>
    );
};
